<template>
  <v-layout row>
    <v-flex>
      <v-btn v-if="user && isCommunityJoined" dark fab right color="teal" slot="activator"
             style="bottom: 30px; right:10px; position: fixed; z-index: 1">
        <v-icon>add</v-icon>
      </v-btn>
      <v-card>
        <v-container fluid grid-list-md>
          <v-list v-if="isCommunityJoined">
            <v-container>
              <v-subheader>Users</v-subheader>

              <template v-for="(user, index) in communityUsers">
                <v-list-tile :key="index" avatar class="mb-3">
                  <v-list-tile-avatar>
                    <v-badge overlap color="teal lighten-2">
                      <v-icon v-if="user.isCommunityOwner" dark small slot="badge">star</v-icon>
                      <v-avatar>
                        <img :src="user.avatar">
                      </v-avatar>
                    </v-badge>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ user.name }}
                      <v-chip  v-if="user.isCommunityOwner"
                               color="teal lighten-2" text-color="white">Community Owner</v-chip>
                      <v-chip  v-if="user.isCommunityNewbie"
                               color="purple lighten-2" text-color="white">Newbie</v-chip>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-container>
          </v-list>
          <div v-else class="text-xs-center">No Access Permission, it's necessary to join the community <router-link to="./">here</router-link>.</div>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'UsersSpace',
  props: {
    user: Object,
    communityUsers: Array,
    isCommunityJoined: Boolean,
    isCommunityOwner: Boolean,
  },
  data() {
    return { };
  },
  methods: { },
};
</script>

<style scoped>
  .v-list__tile__title {
    height: 36px!important;
    line-height: 36px!important;
  }
</style>
